import React from 'react';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { getPrivateAttributes } from '@ally/private';
import { FormTextWrapper } from '../shared';
import { filterTextAreaProps } from '../utils';
import { propsToForward } from '../../tools/utils';
const StyledTextArea = styled.textarea.withConfig({
    shouldForwardProp: propsToForward,
}) `
  ${({ $resizable }) => `
    min-width: 0;
    resize: ${$resizable ? 'vertical' : 'none'};
  `}
`;
const TextArea = React.forwardRef((props, ref) => {
    const { resizable, isPrivate } = props;
    const privateAttrs = isPrivate ? getPrivateAttributes() : {};
    return (React.createElement(FormTextWrapper, null,
        React.createElement(StyledTextArea, Object.assign({}, filterTextAreaProps(props), { ref: ref, "$resizable": !!resizable }, privateAttrs))));
});
const TextAreaWithMarginProps = styled(TextArea)(margin);
export { TextAreaWithMarginProps as TextArea };
//# sourceMappingURL=TextArea.js.map